<h1 mat-dialog-title>Measure</h1>
<div mat-dialog-content>
  <mat-form-field class="w-100">
    <mat-label>ModbusRTU</mat-label>
    <mat-select [(ngModel)]="measure.id">
      @for (rtu of data.modbusRTUs; track rtu) {
        <mat-option [value]="rtu.id" [disabled]="rtu.loggingEnabled" (click)="onModbusSelect(rtu)">
          {{rtu.measureName}} [{{rtu.unit}}] [{{rtu.address}}] @if (rtu.multiplier) {
          <span>[x{{rtu.multiplier}}]</span>
        }
      </mat-option>
    }
  </mat-select>
</mat-form-field>
<mat-form-field class="w-100">
  <mat-label>Neighbours</mat-label>
  <input matInput type="number" step="1" min="0" placeholder="Neighbours" name="neighbours" [(ngModel)]="measure.neighbours">
</mat-form-field>

</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Bezár</button>
  <button mat-button color="primary" (click)="onSaveClick()" translate>SAVE</button>
</div>
